import React from 'react'
import {
  Modal,
  Form,
  Button,
  Message,
  TextArea,
  Image
} from 'semantic-ui-react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import {createAPIClient} from '../../../../../services/api'
import RecurrencePicker from '../new/RecurrencePicker'
import {resolveRecurrenceFromRule} from '../../../../../utils/recurrence'

const {Field} = Form
const modalStyle = {marginTop: '0px !important', marginLeft: 'auto', marginRight: 'auto'}

class EditRepeatRuleModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = this.buildStateFromRule(props.rule)
  }

  buildStateFromRule (rule) {
    if (!rule) {
      return {
        name: '',
        nextRun: undefined,
        recurrence: null,
        error: undefined,
        isLoading: false
      }
    }
    return {
      name: rule.name,
      nextRun: rule.next_run,
      recurrence: resolveRecurrenceFromRule(rule),
      error: undefined,
      isLoading: false
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.rule !== this.props.rule && this.props.rule) {
      this.setState(this.buildStateFromRule(this.props.rule))
    }
  }

  onNameChange (e) {
    this.setState({name: e.target.value})
  }

  onNextRunChange (val) {
    const nextRun = val && val.toISOString()
    let recurrence = Object.assign({}, this.state.recurrence, {
      day_of_month: val ? val.getDate() : this.state.recurrence && this.state.recurrence.day_of_month,
      weekday: val ? val.getDay() : this.state.recurrence && this.state.recurrence.weekday
    })
    this.setState({nextRun, recurrence})
  }

  onRecurrenceChange (recurrence) {
    this.setState({recurrence})
  }

  onSubmit (e) {
    e.preventDefault()
    if (!this.state.name || !this.state.nextRun || !this.state.recurrence) {
      this.setState({error: 'Please fill in all required fields.'})
      return
    }

    this.setState({isLoading: true, error: undefined})
    const api = createAPIClient()
    const recurrence = Object.assign({}, this.state.recurrence, {
      anchor: this.state.recurrence.anchor || this.state.nextRun
    })
    api.put(`/api/repeatrule/${this.props.rule._id}`, {
      name: this.state.name,
      next_run: this.state.nextRun,
      recurrence: recurrence
    })
      .then(() => {
        this.props.onSaved()
      })
      .catch(() => {
        this.setState({isLoading: false, error: 'Failed to update repeat rule.'})
      })
  }

  render () {
    if (!this.props.rule) return null

    return (
      <Modal open={this.props.open} style={modalStyle} onClose={this.props.onClose}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit repeat rule
          <a href='#'>
            <Image
              onClick={this.props.onClose}
              style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}}
              avatar
              src={'/icons/close_432859.svg'}
            />
          </a>
        </Modal.Header>
        <Modal.Content>
          <Form id='editRepeatRuleForm' onSubmit={this.onSubmit.bind(this)}>
            {this.state.error ? (
              <Message negative>
                <Message.Header>{this.state.error}</Message.Header>
              </Message>
            ) : null}
            <Field>
              <label>Rule name*</label>
              <TextArea rows={1} autoHeight required value={this.state.name} onChange={this.onNameChange.bind(this)} />
            </Field>
            <Field>
              <label>Next run*</label>
              <DatePicker
                selected={this.state.nextRun && moment(this.state.nextRun).toDate()}
                showTimeSelect
                timeIntervals={60}
                dateFormat='dd/MM/yyyy h:mm aa'
                onChange={this.onNextRunChange.bind(this)}
              />
            </Field>
            {this.state.nextRun && this.state.recurrence ? (
              <RecurrencePicker
                key={this.props.rule._id}
                editMode
                value={this.state.recurrence}
                startDate={this.state.nextRun}
                onChange={this.onRecurrenceChange.bind(this)}
              />
            ) : null}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.onClose} type='button'>Cancel</Button>
          <Button primary icon='check' content='Save' type='submit' form='editRepeatRuleForm' loading={this.state.isLoading} />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default EditRepeatRuleModal



// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/repeatrulepanel/EditRepeatRuleModal.js